import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from "@angular/forms";
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { AuthService } from '@app/core/auth/auth.service';
import { Router } from '@angular/router';
@Component({
    selector: 'login-form',
    templateUrl: './login-form.component.html'
})
export class LoginFormComponent implements OnInit {

    formGroup: FormGroup;
    showResult = false
    showPassword = false
    loading=false;
    @Input() thirPartyLogin = false
 
    constructor(private formBuilder: FormBuilder,
        private _authService: AuthService,
        private _router: Router
        ) {}

    ngOnInit() {
        this.formGroup = this.formBuilder.group({
            email: ['', [
                Validators.required
            ]],
            password: ['', [
                Validators.required
            ]]
        });
    }
 
    login() {
        this.loading = true;
        this._authService.signIn(this.formGroup.value).subscribe(res=>{
            console.log(res);

            this._router.navigate([`dashboard`]);
        },
        (response) => {
             this.loading = false;

            // Re-enable the form
            this.formGroup.enable();

            // Reset the form
            this.resetForm()

            // // Set the alert
            // this.alert = {
            //     type: 'error',
            //     message: 'Wrong email or password',
            // };

            // // Show the alert
            // this.showAlert = true;
        })
    }

    resetForm(): void{
        this.formGroup.patchValue({
            email: null,
            password: null
            });
    }

    onShowPasswordClick () {
        this.showPassword = !this.showPassword
    }
 
    onReset() {
        this.formGroup.reset();
    }
}
